module.exports = "../../../../platform/assets/pageMainIcon/business_yewuchulilei3.svg";